<template>
  <div>
    <!--上半部分-->
    <div>
      <img class="topbg" src="../assets/topbg_mobile.png">
      <div class="top_content">
        <img class="app_icon" src="../assets/icon.png" />
        <font class="app_name">开心0元购</font>
      </div>
      <font class="des">连续打卡全额返 就在开心0元购</font>
      <div class="btnP">
        <div @click="download()">
          <img class="btnImg" src="~@/assets/bot.png">
          <!-- <a href="https://s3.cn-northwest-1.amazonaws.com.cn/s3.jianos.com/Zero.apk" download="" traget="_blank"> -->
          <font class="btnFont">Android系统下载</font>
          <!-- </a> -->
        </div>
      </div>
    </div>
    <!--下半部分-->
    <div style="margin-bottom:30px">
      <img class="img1" src="~@/assets/right_top.png">
      <div class="WordP">
        <h1>打卡简单 全额返购自主提现</h1>
        <div>只要坚持完成连续打卡任务 即全额返现</div>
        <p>• 进入指定京东或天猫店铺购买想要的指定商品</p>
        <p style="margin:3px 0">• 进入开心0元购注册账号，关联商品 </p>
        <p>• 每日打卡，完成阶段任务自主提现，直至全额</p>
      </div>
      <img class="img1" src="~@/assets/left_bottom.png">
      <div class="WordP">
        <h1>提现便捷 拒绝意外翻车</h1>
        <div>分阶段返现，完成阶段任务即可直接提现</div>
        <p>• 在开心0元购打卡至阶段任务完成</p>
        <p style="margin:3px 0">• 进入领奖处，填写收款账户直接申请提现</p>
        <p>• 全部现金到账，更有神秘福利免费领取</p>
      </div>
    </div>
  </div>
</template>
<!--(1920 px 1082 px)-->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.topbg {
  width: 100%;
  height: auto;
}

.top_content {
  width: auto;
  left: 18%;
  top: 13%;
  position: absolute;
  text-align: left;
  display: flex;
  align-items: center
}

.app_icon {
  width: 60px;
  height: 60px;
}

.app_name {
  font-size: 30px;
  font-weight: bold;
  margin-left: 25px;
}

.des {
  color: #FB4644;
  font-weight: bold;
  font-size: 16px;
  left: 18%;
  top: 24%;
  position: absolute;
}

.btnP {
  position: absolute;
  bottom: 6%;
  display: flex;
  justify-content: center;
  width: 100%;
  height: auto;
}

.btnP div {
  background-color: #FB4644;
  display: flex;
  align-items: center;
  width: auto;
  height: auto;
  border-radius: 20px;
  padding: 5px;
  padding-left: 10px;
  padding-right: 20px;

}

.btnP:active {
  /*transform: scale(10);*/
}

.btnImg {
  width: 30px;
  height: 30px;
}

.btnFont {
  color: white;
  font-size: 20px;
  font-weight: bold;
  margin-left: 10px;
}

.btnFont:active {
  font-size: 18px;
}

.img1 {
  width: 80%;
  height: auto;
  margin-top: 20px;
}

.WordP {
  width: 100%;
  height: auto;
  text-align: center;
}

.WordP div {
  margin: 10px 0;
  font-size: 15px;
}

.WordP h1 {
  font-size: 20px;
}

.WordP p {
  font-size: 12px;
}

</style>
<script>
var downUrl = "https://s3.cn-northwest-1.amazonaws.com.cn/s3.jianos.com/Zero.apk";

function requestApi() {
  var url = 'https://apifreego.jianos.com/app_update';
  var xhr = new XMLHttpRequest();
  xhr.open('get', url, true);
  xhr.setRequestHeader("content-type", "application/json");

  xhr.onload = () => {
    // console.log('xhr.response = ', xhr.response)
    if (xhr.status == 200) {
      var result = JSON.parse(xhr.response);
      // console.log(222,result)
      if (result && result.data && result.data.src) {
        downUrl = result.data.src;
        //if(callback)callback(result.src);
        // console.log('得到的下载地址是 = ' + downUrl)
      }
    }
  }
  xhr.onerror = () => {
    // console.log('xhr.onerror = ', xhr)
  }
  xhr.send();
}

requestApi();

document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';

export default {
  name: 'Android',
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
    }
  },
  created() {
    document.title = '开心0元购'
  },
  methods: {
    download() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        //是微信环境，弹出遮罩
        document.getElementById('adr-mask').style.display = 'block';
        return true;
      } else {
        // TODO 这里弱网环境会有问题
        //不是微信环境，直接下载，
        window.location.href = downUrl;
        return false;
      }
    },
    closeMask() {
      document.getElementById('adr-mask').style.display = 'none';
    }
  }
}

</script>
<!--本地网络地址：   http://192.168.31.101:8082-->
